import { MuiAlert } from './MuiAlert';
import { MuiAppBar } from './MuiAppBar';
import { MuiAutocomplete } from './MuiAutocomplete';
import { MuiBox } from './MuiBox';
import { MuiButton } from './MuiButton';
import { MuiCard } from './MuiCard';
import { MuiCardContent } from './MuiCardContent';
import { MuiCardHeader } from './MuiCardHeader';
import { MuiCssBaseline } from './MuiCssBaseline';
import { MuiDataGrid } from './MuiDataGrid';
import { MuiDialog } from './MuiDialog';
import { MuiDialogActions } from './MuiDialogActions';
import { MuiDialogContent } from './MuiDialogContent';
import { MuiIconButton } from './MuiIconButton';
import { MuiLinearProgress } from './MuiLinearProgress';
import { MuiLink } from './MuiLink';
import { MuiListItemButton } from './MuiListItemButton';
import { MuiMenu } from './MuiMenu';
import { MuiPaper } from './MuiPaper';
import { MuiPickersCalendarHeader } from './MuiPickersCalendarHeader';
import { MuiPickersDay } from './MuiPickersDay';
import { MuiPickersLayout } from './MuiPickersLayout';
import { MuiPickersYear } from './MuiPickersYear';
import { MuiSelect } from './MuiSelect';
import { MuiSlider } from './MuiSlider';
import { MuiSwitch } from './MuiSwitch';
import { MuiTable } from './MuiTable';
import { MuiTableCell } from './MuiTableCell';
import { MuiTableContainer } from './MuiTableContainer';
import { MuiTableRow } from './MuiTableRow';
import { MuiTextField } from './MuiTextField';
import { MuiTooltip } from './MuiTooltip';
import { MuiTypography } from './MuiTypography';

export const defaultThemedMuiComponents = {
  MuiAppBar,
  MuiCssBaseline,
  MuiTypography,
  MuiIconButton,
  MuiCard,
  MuiTable,
  MuiTableCell,
  MuiTableRow,
  MuiTableContainer,
  MuiCardHeader,
  MuiCardContent,
  MuiButton,
  MuiDialogContent,
  MuiDialogActions,
  MuiTextField,
  MuiPaper,
  MuiBox,
  MuiTooltip,
  MuiAutocomplete,
  MuiLink,
  MuiMenu,
  MuiPickersDay,
  MuiPickersCalendarHeader,
  MuiPickersYear,
  MuiPickersLayout,
  MuiLinearProgress,
  MuiDialog,
  MuiListItemButton,
  MuiAlert,
  MuiDataGrid,
  MuiSelect,
  MuiSlider,
  MuiSwitch,
};
